export const BaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  "https://backendshineinlavender.quindl.com";

export const ReviewBaseUrl = BaseUrl;

